import useAppDispatch from "@/core/helpers/useAppDispatch";
import { ChatMessage, ChatTab } from "@/domains/chat/constants/chat.ts";
import { resetMessages, setMessages } from "@/domains/chat/slice";
import {
  getChatBrowserMessage,
  getChatMessage,
  getChatTargetTabs,
  sendChatMessage,
} from "@/domains/chat/helpers/chat.ts";

export default () => {
  const dispatch = useAppDispatch();

  const pushMessage = async (text: string) => {
    const chatMessage: ChatMessage | null = getChatMessage(text);

    if (chatMessage === null) {
      return;
    }

    const chatBrowserMessage = await getChatBrowserMessage(chatMessage);

    if (chatBrowserMessage === null) {
      return;
    }

    const chatTabs: ChatTab[] = getChatTargetTabs(chatMessage.target);
    chatTabs.forEach((tab) => {
      dispatch(setMessages({ message: chatBrowserMessage, tab }));
    });
    await sendChatMessage(chatMessage);
  };

  const clearMessages = () => {
    dispatch(resetMessages());
  };

  return {
    pushMessage,
    clearMessages,
  };
};
